
<template>


  <div>
  <!-- Page Title-->
    <div class="page-title">
      <div class="container">
        <h1>Comment acheter </h1>
        <ul class="breadcrumbs">
          <h2> <strong>  luxuryshopdz est aujourd'hui le numéro 1 en Algerie des ventes de montres origianles  </strong></h2>
        </ul>
      </div>
    </div>

<h2 style="text-align:center;"><span style="color:#FFA500;"><strong>Etape N°1 :</strong></span> <span style="color:#4a4a4a;"><strong> Accédez au site www.luxuryshopdz.com </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/home.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
&darr;&#x2193;
<h2 style="text-align:center;"><span style="color:#FFA500;"><strong>Etape N°2 :</strong></span> <span style="color:#4a4a4a;"><strong> Cliquez sur le produit qui vous intéresse. </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/tous.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
&darr;&#x2193;
<h2 style="text-align:center;"><span style="color:#FFA500;"><strong>Etape N°3 :</strong></span> <span style="color:#4a4a4a;"><strong> Cliquez sur "Ajouter au panier"  </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/produit.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
&darr;&#x2193;

<h2 style="text-align:center;"><span style="color:#FFA500;"><strong>Etape N°4 :</strong></span> <span style="color:#4a4a4a;"><strong> cliquez sur "Commander".  </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/commande.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
&darr;&#x2193;
<h2 style="text-align:center;"><span style="color:#FFA500;"><strong>Etape N°5 :</strong></span> <span style="color:#4a4a4a;"><strong> Remplissez votre numéro de téléphone et cliquez sur "Valider". </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/telephone.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
&darr;&#x2193;
<h2 style="text-align:center;"><span style="color:#FFA500;"><strong>Etape N°6 :</strong></span> <span style="color:#4a4a4a;"><strong> Confirmez votre commande en cliquons  sur "Valider". </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/fourm.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
&darr;&#x2193;
<h2 style="text-align:center;"><span style="color:#FFA500;"> <strong>Etape N°7 :</strong></span> <span style="color:#4a4a4a;"><strong>  L'équipe de luxuryshopdz, vous joindra par téléphone pour finaliser votre commande. </strong></span></h2>
<h2 style="text-align:center;"><img src="static/img/shop/categories/fourmfinal.png"  width="70%" alt="Etape_01 Ombre (1).png"></h2>
    <!-- Page Content-->




      </div>

</template>

<script>
export default {};
</script>

<style scoped>
.page-title {
  margin-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/achat.vue